import {
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  Grid,
  Dialog,
  Select,
  MenuItem,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { actions, reducer, sliceKey } from "../../../redux/slice";
import { usePropertySaga } from "../../../redux/saga";
import { style } from "@mui/system";
import useStyles from "./styles";
import OtpInput from "react-otp-input";
import { LoggerClass as Logger } from "utils/logger";

type Props = {};
const Delete = ({
  showPopup,
  closePopup,
  handleClose = () => {},
  handleChange = () => {},
}) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: usePropertySaga });
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [reportType, setReportType] = useState<any>(null);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [timeRange, setTimeRane] = useState("");
  const [error, setError] = useState(false);
  const [otp, setOtp] = useState("");
  const [disable, setDisable] = useState(true);

  const close = () => {
    setShow(false);
    closePopup();
  };

  useEffect(() => {
    if (otp?.length === 4) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [otp?.length]);

  useEffect(() => {
    setShow(showPopup);
  }, [showPopup]);

  const handleReportTypeChange = (event) => {
    const option = event.target.value;
    Logger.log(event.target);
    setReportType(option);
  };

  return (
    <Dialog open={show} className={styles.popup}>
      <Box sx={{ display: "flex", flexDirection: "column", margin: "16px" }}>
        <div
          style={{
            fontFamily: "Open Sans",
            fontSize: 18,
            color: "#192342",
            fontWeight: "400",
            textAlign: "center",
          }}
        >
          Do you really want to delete the
          <span
            style={{
              fontFamily: "Open Sans",
              fontSize: 18,
              color: "#192342",
              fontWeight: "600",
            }}
          >
            {" "}
            Tenant John Snow
          </span>
          from the property
          <span
            style={{
              fontFamily: "Open Sans",
              fontSize: 18,
              color: "#192342",
              fontWeight: "600",
            }}
          >
            {" "}
            3429 Adkins, Rd. NW Atlanta, GA 30331?
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <Button
            className={styles.outlinebtn}
            onClick={handleChange}
            style={{ marginLeft: 0 }}
            variant="outlined"
          >
            Delete
          </Button>
          <Button
            className={styles.signInButton}
            onClick={close}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default Delete;
